import { ProductCatalog } from "../../components/site/ProductCatalog";

export default function Products() {
  return (
    <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8 lg:py-20">
      <p className="eyebrow rise">Digital products</p>
      <h1 className="rise d1 mt-3 text-4xl font-extrabold text-white sm:text-5xl">The Raphanex catalogue</h1>
      <p className="rise d2 mt-4 max-w-2xl text-slate-400">Browse digital products. Create an account to purchase — access is delivered instantly after payment.</p>
      <div className="mt-12"><ProductCatalog base="/products" /></div>
    </div>
  );
}
